module.exports = __webpack_public_path__ + "bf78193f3b85a0203f5e40fec272d668.png";